import request from "@/utils/request";

export function getMaterialGroupList(data){
  return request({
    url:'/osp/materialView/getMaterialGroupList',
    method:'post',
    data: data
  })
}

export function getMaterialLogoList(data){
  return request({
    url:'/osp/materialView/getMaterialLogoList',
    method:'post',
    data: data
  })
}

export function getMaterialModelList(data){
  return request({
    url:'/osp/materialView/getMaterialModelList',
    method:'post',
    data: data
  })
}
